import React, {memo, useState, useRef, useMemo, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import OtherAboveFold from '../../components/OtherAboveFold';
import TravelWorldEnjoyWhat from '../../components/TravelWorldEnjoyWhat';
import BusinessPhilosophy from '../../components/BusinessPhilosophy';
import { isMath, isNormalZhEnCss, getClientRect, delay } from '../../utils';

import styles from './styles.module.scss';

import bannerImg_1 from '../../assets/img/aboutUs/banner/aboutus.jpg';
import bannerImg_2 from '../../assets/img/aboutUs/banner/aboutusm.jpg';
import svgTitle from '../../assets/img/aboutUs/banner/aboutTitleM.svg';

const Index = memo(() => {

  const dispatch = useDispatch();
  const { handleNewsDetail } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { aboutUs } = useSelector(({localesReducer}) => localesReducer.i18n);
  const { scrolVal, scrolFidx } = useSelector(({scrollNumReducer}) => scrollNumReducer);


  // OtherAboveFold
  const [bannerImg,  setBannerImg] = useState(bannerImg_1);

  const [innerContentHeight,  setInnerContentHeight] = useState(1656);
  const [innerContentPaddingTop,  setInnerContentPaddingTop] = useState(455.56);
  const [svgWidth, setSvgWidth] = useState(905.55);
  const [svgHeight, setHeight] = useState(210.98);
  const [otherMarginTitleBot,  setOtherMarginTitleBot] = useState(20.31);

  // 样式判断
  const normal = useMemo(() => {
    if(recReSizeReducer > 1920){
      setBannerImg(bannerImg_1);
      setInnerContentHeight(1656);
      setInnerContentPaddingTop(444);
      setOtherMarginTitleBot(20.31);
      setSvgWidth(905.55);
      setHeight(210.98);
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      setBannerImg(bannerImg_1);
      setInnerContentHeight(1242);
      setInnerContentPaddingTop(333);
      setOtherMarginTitleBot(14.7);
      setSvgWidth(679.16);
      setHeight(158.24);
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      setBannerImg(bannerImg_1);
      setInnerContentHeight(931.5);
      setInnerContentPaddingTop(249.75);
      setOtherMarginTitleBot(11.03);
      setSvgWidth(509.37);
      setHeight(118.68);
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      setBannerImg(bannerImg_1);
      setInnerContentHeight(662.4);
      setInnerContentPaddingTop(177.6);
      setOtherMarginTitleBot(8.04);
      setSvgWidth(362.22);
      setHeight(84.39);
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      setBannerImg(bannerImg_2);
      setInnerContentHeight(1440);
      setInnerContentPaddingTop(394);
      setOtherMarginTitleBot(32.67);
      setSvgWidth(522.99);
      setHeight(121.85);
      return styles.normalSm;
    }
  }, [recReSizeReducer]);

  const transitionFed = 'all 1.8s';
  const opacityStart = 0;
  const opacityEnd = 1;
  const translateYStart = `translateY(${isMath(recReSizeReducer, 300)})`;
  const translateYEnd = `translateY(${isMath(recReSizeReducer, 0)})`;
  const translateYOtherEnd = `translateY(${isMath(recReSizeReducer, 50)})`;
  const translateScaleStart = `scale(1.5)`;
  const translateScaleEnd = `scale(1)`;

  // 背景透明度 start
  const initFedOpacityStart = {
    opacity: opacityStart,
    transition: transitionFed,
  };
  // 背景透明度 end


  // 位移加透明度 start
  const initFedStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateYStart,
  };

  const initFedScaleStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateScaleStart,
  };
  // 位移加透明度 end

  // TODO: onePage start
  const oneAnimatedScreenRef = useRef(null);
  const [oneAnimatedScreenFlag, setOneAnimatedScreenFlag] = useState(true);
  const [oneAnimatedScreenStyle, setOneAnimatedScreenStyleApi] = useState(initFedScaleStart);
  const oneAnimatedScreenScroll = () => {
      if (oneAnimatedScreenFlag) {
        setOneAnimatedScreenStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateScaleStart,
        });
      }else{
        setOneAnimatedScreenStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateScaleEnd,
        });
      }
  }
  // TODO: onePage end

  // TODO: twoPage start
  const twoAnimatedTravelWorldEnjoyWhatRef = useRef(null);
  const [twoAnimatedTravelWorldEnjoyWhatFlag, setTwoAnimatedTravelWorldEnjoyWhatFlag] = useState(true);
  const [twoAnimatedTravelWorldEnjoyWhatStyle, setTwoAnimatedTravelWorldEnjoyWhatStyleApi] = useState(initFedStart);

  const twoAnimatedTravelWorldEnjoyWhatScroll = () => {
      if (twoAnimatedTravelWorldEnjoyWhatFlag) {
        setTwoAnimatedTravelWorldEnjoyWhatStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
      }else{
        setTwoAnimatedTravelWorldEnjoyWhatStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
      }
  }

  // TODO: twoPage end

  // TODO: threePage start
  const threeAnimatedBusinessPhilosophyRef = useRef(null);
  const [threeAnimatedBusinessPhilosophyStyle, setThreeAnimatedBusinessPhilosophyStyleApi] = useState(initFedStart);

  const threeAnimatedBusinessPhilosophyScroll = (curEle) => {
    let { isClientRect } = getClientRect(curEle, 600); // 当前元素
      if (isClientRect) {
        setThreeAnimatedBusinessPhilosophyStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setThreeAnimatedBusinessPhilosophyStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }

  const threeAnimateScroll = () => {
      if(recReSizeReducer > 750){
          // PC
          threeAnimatedBusinessPhilosophyScroll(threeAnimatedBusinessPhilosophyRef);
      }else{
          // H5
          threeAnimatedBusinessPhilosophyScroll(threeAnimatedBusinessPhilosophyRef);
      }
  }
  // TODO: threePage end


  useEffect(() => {
    setOneAnimatedScreenFlag(false);
    setTwoAnimatedTravelWorldEnjoyWhatFlag(false);

    delay(1000, () => {
      oneAnimatedScreenScroll();
    });
    delay(3000, () => {
      twoAnimatedTravelWorldEnjoyWhatScroll();
    });
    
  }, [oneAnimatedScreenFlag, twoAnimatedTravelWorldEnjoyWhatFlag]);

  useEffect(() => {
    threeAnimateScroll();
  }, [scrolVal]);


  const { travelWorldEnjoyWhatData, businessPhilosophyData } = aboutUs;
  return (
      <div className={normal}>
        <div 
          className="onePage"
          ref={oneAnimatedScreenRef}
          style={oneAnimatedScreenStyle}
        >
          <OtherAboveFold
              config={{
                bgImg: bannerImg,
                svgTitle: svgTitle,
                title: '关于鼎盛',
                innerContentStyles: {
                  width: `100%`,
                  height: isMath(recReSizeReducer,innerContentHeight),
                  paddingTop: isMath(recReSizeReducer,innerContentPaddingTop),
                },
                otherStyle: {
                  svgTitleCss: {
                    width: isMath(recReSizeReducer,svgWidth),
                    height: isMath(recReSizeReducer,svgHeight),
                    margin: `0 auto ${isMath(recReSizeReducer,otherMarginTitleBot)} auto`, //
                  },
                  subTitleStyle: {
                    color: '#97C0DC',
                  }
                },

              }}
          />
        </div>
        <div 
          className="twoPage"
          ref={twoAnimatedTravelWorldEnjoyWhatRef}
          style={twoAnimatedTravelWorldEnjoyWhatStyle}
        >
          <TravelWorldEnjoyWhat
              config={{
                data: travelWorldEnjoyWhatData
              }}
          />
        </div>
        <div 
          className="threePage"
          ref={threeAnimatedBusinessPhilosophyRef}
          style={threeAnimatedBusinessPhilosophyStyle}
        >
          <BusinessPhilosophy
              config={{
                data: businessPhilosophyData
              }}
          />
        </div>
      </div>
  );
});
export default Index;
